import { enableProdMode, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddResourceComponent } from './addResource/addResource.component';
import { AdminDashboardComponent } from './adminDashboard/adminDashboard.component';
import { BehavioralSkillMasterComponent } from './behavioralSkillMaster';
import { DashboardComponent } from './dashboard';
import { FunctionalSkillMasterComponent } from './functionalSkillMaster/functionalSkillMaster.component';
import { IBUComponent } from './ibu/ibu.component';
import { InterestedUsersComponent } from './interested-users/interested-users.component';
import { LoginComponent } from './login';
import { ManagementUsersComponent } from './managementUser/managementusers.component';
import { ManagerRatingSectionComponent } from './managerRatingSection/managerRatingSection.component';
import { NominateComponent } from './nominate/nominate.component';
import { PositionLadderComponent } from './position-ladder/position-ladder.component';
import { RatingHistoryComponent } from './rating-history/rating-history.component';
import { InterventionComponent } from './resourceIntervention/intervention.component';
import { ScoreComputationComponent } from './scoreComputation/scoreComputation.component';
import { SelfRatingSectionComponent } from './selfRatingSection/selfRatingSection.component';
import { SkillRatingMasterComponent } from './skillRatingMaster/skillRatingMaster.component';
import { SkillRatingSectionComponent } from './skillRatingSection/skillRatingSection.component';
import { AdminUserComponent } from './superAdminUser/adminuser.component';
import { TowerComponent } from './tower/tower.component';
import { TrainingComponent } from './training/training.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { CompetencyReportComponent } from './competency-report/competency-report.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'addResource', component: AddResourceComponent },
  { path: 'intervention', component: InterventionComponent },
  { path: 'scoreComputation', component: ScoreComputationComponent },
  { path: 'skillRating', component: SkillRatingSectionComponent },
  { path: 'selfRating', component: SelfRatingSectionComponent },
  { path: 'managerRating', component: ManagerRatingSectionComponent },
  { path: 'adminDashboard', component: AdminDashboardComponent },
  { path: 'ibu', component: IBUComponent },
  { path: 'tower', component: TowerComponent },
  { path: 'manageUsers', component: ManagementUsersComponent },
  { path: 'superAdminUser', component: AdminUserComponent },
  { path: 'funSkillMaster', component: FunctionalSkillMasterComponent },
  { path: 'behSkillMaster', component: BehavioralSkillMasterComponent },
  { path: 'skillRatingMaster', component: SkillRatingMasterComponent },
  { path: 'userDashboard', component: UserDashboardComponent },
  { path: 'position-ladder', component: PositionLadderComponent },
  { path: 'training', component: TrainingComponent },
  { path: 'nominate', component: NominateComponent },
  { path: 'interested-users', component: InterestedUsersComponent },
  { path: 'rating-history', component: RatingHistoryComponent },
  { path: 'competencyReport', component: CompetencyReportComponent },
  { path: '**', redirectTo: '' }
];
enableProdMode();
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
